import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { cn } from '../../lib/utils';
import { ICON } from '../ui';

interface Props {
  value: string;
  onChange: (v: string) => void;
  error?: string;
  id?: string;
  placeholder?: string;
  revealDefault?: boolean;
}

/**
 * BSN-invoerveld met masking. Standaard verbergt het cijfers (●●●●●●●●●). Klik op
 * het oog om ze te tonen. Accepteert alleen cijfers; strip overige karakters.
 */
export function BsnField({ value, onChange, error, id = 'bsn', placeholder = '123456789', revealDefault = false }: Props) {
  const [reveal, setReveal] = useState(revealDefault);

  return (
    <div className="relative">
      <input
        id={id}
        type={reveal ? 'text' : 'password'}
        inputMode="numeric"
        autoComplete="off"
        className={cn('input pr-10 font-mono', error && 'border-red-500 focus:border-red-500')}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, 9))}
        aria-invalid={!!error}
        aria-describedby={error ? `${id}-error` : undefined}
      />
      <button
        type="button"
        onClick={() => setReveal((r) => !r)}
        className="absolute right-1 top-1/2 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-md text-slate-400 transition-colors duration-fast hover:text-slate-100"
        aria-label={reveal ? 'BSN verbergen' : 'BSN tonen'}
        title={reveal ? 'BSN verbergen' : 'BSN tonen'}
      >
        {reveal ? <EyeOff className={ICON.sm} aria-hidden /> : <Eye className={ICON.sm} aria-hidden />}
      </button>
    </div>
  );
}
